/**
 * @generated SignedSource<<96edd6a17782b896215a6cbf557e56d4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type LegacyScriptTagSettingTabContainer_Mutation$variables = {
  siteId: string;
  userTag?: string | null;
};
export type LegacyScriptTagSettingTabContainer_MutationVariables = LegacyScriptTagSettingTabContainer_Mutation$variables;
export type LegacyScriptTagSettingTabContainer_Mutation$data = {
  readonly upsertUserTag: {
    readonly site: {
      readonly id: string;
      readonly embedTag: string | null;
    };
  } | null;
};
export type LegacyScriptTagSettingTabContainer_MutationResponse = LegacyScriptTagSettingTabContainer_Mutation$data;
export type LegacyScriptTagSettingTabContainer_Mutation = {
  variables: LegacyScriptTagSettingTabContainer_MutationVariables;
  response: LegacyScriptTagSettingTabContainer_Mutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "siteId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userTag"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "siteId",
            "variableName": "siteId"
          },
          {
            "kind": "Variable",
            "name": "userTag",
            "variableName": "userTag"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "UpsertUserTagPayload",
    "kind": "LinkedField",
    "name": "upsertUserTag",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Site",
        "kind": "LinkedField",
        "name": "site",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "embedTag",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LegacyScriptTagSettingTabContainer_Mutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LegacyScriptTagSettingTabContainer_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "df60aced7ce4c0bed593459ac7696cd8",
    "id": null,
    "metadata": {},
    "name": "LegacyScriptTagSettingTabContainer_Mutation",
    "operationKind": "mutation",
    "text": "mutation LegacyScriptTagSettingTabContainer_Mutation(\n  $siteId: ID!\n  $userTag: String\n) {\n  upsertUserTag(input: {siteId: $siteId, userTag: $userTag}) {\n    site {\n      id\n      embedTag\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "44507e358dd89a2e174531e7fc3e3508";

export default node;
